import React, { useState } from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import { Icon } from 'ui';
import RelatedUrlsTableBody from './RelatedUrlsTableBody';

const RelatedUrlsPage = ({ i18n, types, path, param }) => {
  const [isFormVisible, setFormVisible] = useState(false);
  const hasChromeExtensionLinkToRelatedUrls = useFeatureFlags([
    'chrome_extension_link_to_external_urls',
  ]);
  const hasChromeExtensionOnPageContextMapping = useFeatureFlags([
    'chrome_extension_on_page_context_mapping',
  ]);
  const features = {
    chrome_extension_link_to_external_urls: hasChromeExtensionLinkToRelatedUrls,
    chrome_extension_on_page_context_mapping:
      hasChromeExtensionOnPageContextMapping,
  };

  return (
    <div className="RelatedUrlsPage  ml-24 mr-24">
      <header className="RelatedUrlsPage-header">
        <div>
          <div className="Index-header">
            <h1 className="Index-title">{i18n.page_header}</h1>
          </div>
          <div className="Wrapper--thick">
            <p className="HelpText HelpText--mediumGray HelpText--noBottomMargin">
              {i18n.page_instructions}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="NewURLButton NewButton NewButton--white"
          onClick={() => setFormVisible(true)}
        >
          <Icon name="add" className="mr-4 c-brand-gray-dark" />
          {i18n.add_button}
        </button>
      </header>
      <div className="RelatedUrlsTable FlexboxTable">
        <div className="FlexboxTable-header">
          <div className="FlexboxTable-cell RelatedUrlsTable-leftCell">
            {i18n.first_column_header}
          </div>
          <div className="FlexboxTable-cell">
            {i18n.related_content_header}
            <span
              className="ml-4 h-ci"
              data-toggle="tooltip"
              title={i18n.header_tooltip}
              data-placement="top"
            >
              <Icon name="info" />
            </span>
          </div>
          <div className="FlexboxTable-cell">
            {i18n.groups_header}
            <span
              className="ml-4 h-ci"
              data-toggle="tooltip"
              title={i18n.header_groups_tooltip}
              data-placement="top"
            >
              <Icon name="info" />
            </span>
          </div>
        </div>

        <RelatedUrlsTableBody
          i18n={i18n}
          types={types}
          path={path}
          param={param}
          features={features}
          newMappingFormVisible={isFormVisible}
          showNewMappingForm={() => setFormVisible(true)}
          hideNewMappingForm={() => setFormVisible(false)}
        />
      </div>
    </div>
  );
};

export default RelatedUrlsPage;
